import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { switchToOtherZone, getZonePreference, setZonePreference } from '../utils/zoneSwitch';

const ZoneSwitch = () => {
  const { t } = useTranslation();
  const [pref, setPref] = useState(getZonePreference());

  return (
    <>
      <a className="menu-item" onClick={(e) => { e.preventDefault(); switchToOtherZone(); }}>
        {t("settings.switchToNewZone", "Перейти в новую 2Д-зону")}
      </a>
      <div className="menu-item" style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 12, color: "#888" }}>
        <span style={{ whiteSpace: "nowrap" }}>{t("settings.onLogin", "При входе")}:</span>
        <select
          value={pref}
          onChange={(e) => { setPref(e.target.value); setZonePreference(e.target.value); }}
          style={{ flex: 1, minWidth: 0, height: "auto", marginBottom: 0, background: "transparent", color: "#666", border: "1px solid #ddd", borderRadius: 4, padding: "5px 18px 5px 6px", fontSize: 12, lineHeight: "16px", cursor: "pointer" }}
        >
          <option value="none">{t("settings.dontSwitch", "Не переключать")}</option>
          <option value="new">{t("settings.openNew", "Открывать новую")}</option>
          <option value="old">{t("settings.openOld", "Открывать старую")}</option>
        </select>
      </div>
    </>
  );
};

export default ZoneSwitch;
